export function safeAuthReturn(value: unknown): string | undefined {
	if (
		typeof value !== 'string' ||
		!value.startsWith('/') ||
		value.length > 4096
	)
		return;
	let decoded = value;
	for (let n = 0; n < 4; n++) {
		if (
			!decoded.startsWith('/') ||
			decoded.startsWith('//') ||
			/[\\\u0000-\u0020\u007f]/.test(decoded)
		)
			return;
		try {
			const next = decodeURIComponent(decoded);
			if (next === decoded) return value;
			decoded = next;
		} catch {
			return;
		}
	}
	return;
}
export function authHref(path: string, target?: unknown): string {
	const redirect = safeAuthReturn(target);
	return redirect
		? `${path}${path.includes('?') ? '&' : '?'}redirect=${encodeURIComponent(redirect)}`
		: path;
}
